import './monitoring'

import { documentHeight } from '@helpers/documentHeight'

window.addEventListener('resize', documentHeight)

documentHeight()
